import { render, staticRenderFns } from "./dialog-base.vue?vue&type=template&id=493831ea&scoped=true"
import script from "./dialog-base.vue?vue&type=script&lang=ts"
export * from "./dialog-base.vue?vue&type=script&lang=ts"
import style0 from "./dialog-base.vue?vue&type=style&index=0&id=493831ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493831ea",
  null
  
)

export default component.exports